export const DEFAULT_DYNAMICS_CRM_SYNCED_ENTITY_TYPES = [
    'systemuser',
    'account',
    'contact',
    'appointment',
    'email',
    'phonecall',
    'xs_minutes',
    'task',
    'xs_project',
    'xs_offer',
    'xs_agreement',
    'xs_offerproduct',
];
/**
 * BrightWork `bw_project` subtype — the top-level delivery project. Its child
 * WBS tasks (`BRIGHTWORK_PROJECT_TASK_SUBTYPE`) link back via
 * `associations.externalId`. Single source of truth — import everywhere the
 * subtype is matched instead of re-typing the literal.
 */
export const BRIGHTWORK_PROJECT_SUBTYPE = 'bw_project';
/** BrightWork `bw_projecttask` subtype — a single row in a project's WBS. */
export const BRIGHTWORK_PROJECT_TASK_SUBTYPE = 'bw_projecttask';
/**
 * Opt-in default for tenants with the BrightWork 365 PPM solution installed
 * in the same Dataverse env. These ride the existing
 * `DynamicsCrmIntegrationConnection.syncedEntityTypes` array — the BrightWork
 * adapter picks them out by entity-name prefix (`bw_*` / `bwc_*`). This is
 * NOT folded into the Dynamics CRM default because most tenants don't have
 * BrightWork installed; the BrightWork adapter no-ops in those envs anyway
 * (discovery probe returns 404).
 */
export const DEFAULT_BRIGHTWORK_SYNCED_ENTITY_TYPES = [
    BRIGHTWORK_PROJECT_SUBTYPE,
    BRIGHTWORK_PROJECT_TASK_SUBTYPE,
    'bw_assignment',
    'bw_issue',
    'bw_portfolio',
    'bw_program',
    'bw_statusreport',
    'bwc_timeentry',
    'bwc_timesheet',
];
/**
 * BrightWork tables live under these prefixes — `bw_*` for the core PPM
 * solution, `bwc_*` for the BrightWork-Cosmic timesheet add-on. Both adapters
 * that share the Dataverse connection use this to partition ownership of
 * `syncedEntityTypes`.
 */
export const BRIGHTWORK_ENTITY_PREFIXES = ['bw_', 'bwc_'];
export function isBrightworkEntityType(entityType) {
    return BRIGHTWORK_ENTITY_PREFIXES.some((prefix) => entityType.startsWith(prefix));
}
// ─── File change types ───
export var FileChangeType;
(function (FileChangeType) {
    FileChangeType["CREATED"] = "created";
    FileChangeType["MODIFIED"] = "modified";
    FileChangeType["DELETED"] = "deleted";
})(FileChangeType || (FileChangeType = {}));
